import React, { useId } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';

export interface DashboardCollectedLeafDecorationProps {
  sx?: SxProps<Theme>;
}

/** Decorative leaf overlay for the Practice Insights “Collected” tile (matches design SVG). */
export const DashboardCollectedLeafDecoration: React.FC<DashboardCollectedLeafDecorationProps> = ({ sx }) => {
  const rawId = useId();
  const clipId = `collected-leaf-${rawId.replace(/[^a-zA-Z0-9_-]/g, '')}`;

  return (
    <Box
      component="svg"
      width={66}
      height={71}
      viewBox="0 0 66 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      sx={{
        position: 'absolute',
        pointerEvents: 'none',
        flexShrink: 0,
        ...sx,
      }}
    >
      <defs>
        <clipPath id={clipId}>
          <rect width="54.6547" height="69.9647" fill="white" transform="translate(41.3789 70.6758) rotate(-139.208)" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M43.2335 29.3029C36.1072 37.4642 28.9808 45.6255 21.8555 53.7876L48.6951 50.7413C47.03 48.2601 44.6868 44.0593 43.6325 38.3842C42.9657 34.7945 43.0079 31.6613 43.2325 29.3021L43.2335 29.3029Z"
          fill="white"
          fillOpacity={0.15}
        />
        <path
          d="M40.7098 27.1655C33.6792 35.4094 26.6487 43.6534 19.6172 51.8965L18.7028 24.8982C21.4009 26.1823 25.8995 27.8855 31.6678 28.0979C35.3163 28.2322 38.4097 27.732 40.7106 27.1645L40.7098 27.1655Z"
          fill="white"
          fillOpacity={0.15}
        />
        <path
          d="M51.8783 50.2407C65.6498 45.8104 75.0484 34.2666 75.5045 21.7043C75.9097 10.5217 69.0804 2.59153 67.2111 0.554077C64.1447 4.23718 61.0784 7.92029 58.0128 11.6024C57.4262 13.6376 57.1843 15.372 57.0771 16.6212C56.758 20.3058 57.3032 23.2425 57.6709 25.1572C57.9242 26.4785 58.2074 27.56 58.4192 28.3059C58.7583 29.2702 58.1931 30.1575 57.564 30.263C57.0866 30.3439 56.5041 29.9849 56.2224 29.3626C55.5728 27.2497 54.9633 24.707 54.5977 21.7984C54.318 19.5687 54.2332 17.5255 54.2541 15.7257C52.2294 17.6209 49.6305 20.6364 48.0066 24.9327C43.3783 37.1813 50.8739 48.7423 51.8774 50.2399L51.8783 50.2407Z"
          fill="white"
          fillOpacity={0.15}
        />
        <path
          d="M18.6351 21.6002C21.0564 7.33187 31.0745 -3.64227 43.4067 -5.94777C54.1277 -7.95268 62.7955 -2.69508 65.2003 -1.11946C62.1201 2.54672 59.0408 6.21194 55.9596 9.8773C54.0322 10.7554 52.3519 11.2486 51.1318 11.5374C47.5336 12.3923 44.5487 12.2827 42.6008 12.1991C41.2567 12.142 40.1454 12.0201 39.3766 11.9197C38.373 11.7254 37.5779 12.4144 37.5656 13.0521C37.5555 13.5363 37.9958 14.0599 38.6527 14.2475C40.8379 14.5809 43.4424 14.8118 46.3732 14.7477C48.6198 14.6981 50.6534 14.4831 52.4308 14.1989C50.8523 16.4793 48.2496 19.4915 44.2372 21.7266C32.7978 28.0975 20.2643 22.3745 18.636 21.601L18.6351 21.6002Z"
          fill="white"
          fillOpacity={0.15}
        />
      </g>
    </Box>
  );
};
